export default __webpack_public_path__ + "static/media/binary.e16709a0.png";